module.exports = __webpack_public_path__ + "img/jypx-6.98176389.webp";